module.exports = __webpack_public_path__ + "media/application/images/projects/secondary_nav/extreme-environments-987cf89f43ff4f1c7d2dcd42317bee93.jpg";